export default {
    text_1: "Položky a ceny",
    text_2: "Položky a ceny",
    text_3: "V této sekci si můžeš vytvořit vlastní databázi položek a jejich cen, uložit si je do budoucna a následně je při tvorbě nabídky jen vybrat ze seznamu",
    text_4: "Vytvořit novou položku",
    text_5: "Upravit položku",
    text_6: "Smazat položku",
    text_7: "SKU",
    text_8: "Interní název",
    text_9: "Veřejný název",
    text_10: "Cena bez DPH",
    text_11: "Cena s DPH",

    text_12: "Jste si jistí?",
    text_13: "Opravdu chceš smazat položku?",
    text_14: "Ne",
    text_15: "Ano",
    text_16: "Položka byla úspěšně smazána",
    text_17: "Položka byla úspěšně vytvořena",
    text_18: "Položka byla úspěšně upravena",

    text_20: "Nová položka",
    text_21: "Úprava položky",
    text_22: "Interní název položky (POVINNÉ)",
    text_23: "Interní název slouží pro tvoji evidenci",
    text_24: "Veřejný název položky",
    text_25: "Veřejný název budeme používat v cenové nabídce",
    text_26: "ID / SKU",
    text_27: "Pokud používáš skladové hospodářství, můžeš si zaznačit ID / SKU",
    text_28: "interní Popis položky",
    text_29: "Interní popis slouží pro tebe.",
    text_30: "Text",
    text_31: "veřejný Popis položky",
    text_32: "Veřejný popis budeme používat v cenové nabídce",
    text_33: "Cena položky",

    text_34: "Nastavit cenu s DPH",
    text_35: "Nastavit cenu s ",
    text_36: "% DPH",
    text_37: "Cena položky s DPH",
    text_38: "Uložit položku",

    text_39: "ID / SKU / Název položky",
};
